import { page2Images } from "../../../../assets/Images/About/index";
const info = [
  {
    id: 1,
    img: page2Images.i1,
    name: "Jennifer Soft",
    proffesion: "Founder and CEO",
    biogrophie:"Vivamus cursus leo nec sem feugiat sagittis. Duis ut feugiat odio, sit amet accumsan odio.",
    twitter: "icon-twitter",
    facebook: "icon-facebook",
    instagram: "icon-instagram",
    youtube: "",
  },
  {
    id: 2,
    img: page2Images.i2,
    name: "Daisy Walker",
    proffesion: "Executive Chef",
    biogrophie:"Praesent non vulputate elit. Orci varius natoque et magnis dis parturient, nascetur ridiculus mus.",
    twitter: "icon-twitter",
    facebook: "icon-facebook",
    instagram: "",
    youtube: "",
  },

  {
    id: 3,
    img: page2Images.i3,
    name: "Florence Nelson",
    proffesion: "Kitchen Manager",
    biogrophie:"Aenean sapien sem, ultricies sed vulputate et, auctor vel mauris. Integer sit amet diam eget est facilisis lacinia vitae.",
    twitter: "",
    facebook: "icon-facebook",
    instagram: "icon-instagram",
    youtube: "",
  },
  {
    id: 4,
    img: page2Images.i4,
    name: "Valentina Martin",
    proffesion: "Culinary Director",
    biogrophie:"Praesent non vulputate elit. Orci varius natoque penatibus et magnis montes, nascetur ridiculus mus.",
    twitter: "icon-twitter",
    facebook: "icon-facebook",
    instagram: "icon-instagram",
    youtube: "icon-youtube",
  },
];
export default info;
